import {needAuth} from "../instance/Instance";

async function getDailyCheckReportList(search, pageable) {
    console.log(">> 일일체크현황 목록 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/evaluation/dailyCheck?'+pageStr,search);
    }catch (error){
        if (error?.response?.data) {
            return error.response;
        }
        return error;
    }
}

async function saveDailyCheckReport(data, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    formData.append(
        "dailyCheckReportRequestDto",
        new Blob([JSON.stringify(data)], { type: "application/json" })
    );
    try {
        return await needAuth.post(`/evaluation/dailyCheck/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error
    }
}

async function getDailyCheckReport(id){
    try {
        return await needAuth.get(`/evaluation/dailyCheck/${id}`);
    }catch (error){
        return error
    }
}

async function removeDailyCheckReport(ids) {
    try {
        return await needAuth.put('/evaluation/dailyCheck/delete', ids);
    }catch (error){
        return error
    }
}

async function updateDailyCheckReport(data) {
    try {
        return await needAuth.put(`/evaluation/dailyCheck/update`, data);
    }catch (error){
        return error
    }
}

export {
    getDailyCheckReportList,
    saveDailyCheckReport,
    getDailyCheckReport,
    removeDailyCheckReport,
    updateDailyCheckReport
}